import { ModalProps } from "../../types/types";

const Modal: React.FC<ModalProps> = ({
  isModalOpen,
  onClick,
  title,
  children,
}) => {
  const handleBackgroundClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClick();
    }
  };

  return (
    <>
      <div
        className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 transition-opacity duration-300 ${
          isModalOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={handleBackgroundClick}
      >
        <div
          className={`bg-white rounded-lg w-11/12 max-w-2xl p-6 transform transition-transform duration-300 overflow-y-auto scrollbar-hide ${
            isModalOpen ? "scale-100" : "scale-90"
          }`}
          style={{ maxHeight: "90vh" }}
        >
          <h2 className="text-lg font-bold mb-4 text-dark">{title}</h2>
          {children}
          <button
            type="button"
            className="px-5 py-1.5 border rounded-lg hover:bg-gray-100 transition w-full my-2"
            onClick={onClick}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default Modal;
